import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import LoginForm from "@/components/Login/LoginForm.vue";
import RegisterForm from "@/components/Login/RegisterForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginIndex',
    props: {
        sessionCsrfToken: null,
        redirect: { default: undefined },
        termsUrl: { default: undefined },
        welcomeUrl: { default: undefined },
        enableOidc: { type: Boolean },
        showLoginLink: { type: Boolean, default: true },
        showResetLink: { type: Boolean, default: true },
        mailingJoinAddr: { default: undefined },
        allowUserCreation: { type: Boolean },
        preferCustosLogin: { type: Boolean },
        serverMailConfigured: { type: Boolean },
        showWelcomeWithLogin: { type: Boolean },
        registrationWarningMessage: { default: undefined }
    },
    setup(__props) {
        const showLogin = ref(true);
        function toggleLogin() {
            showLogin.value = !showLogin.value;
        }
        return { __sfc: true, showLogin, toggleLogin, LoginForm, RegisterForm };
    }
});
